<script>
import GanttHeaderItem from '@/components/gantt/GanttHeaderItem.vue';

export default {
  name: 'GanttHeader',
  components: { GanttHeaderItem },
  props: {
    header: Object,
    contentHeight: Number,
    headerShift: Number,
    width: Number,
  },
  data() {
    return {
      hide: false,
      timeoutId: null,
    };
  },
  watch: {
    headerShift() {
      this.hide = true;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.hide = false;
      }, 10);
    },
  },
};
</script>

<template lang="pug">
  g(id="header")
    //rect(fill="white" x="0" y="0" height="30" width="30")
    template(v-if="!hide")
      rect(v-if="!hide" :x="0" :y="headerShift" :height="70" :width="width" fill="#F8F9FC")
      GanttHeaderItem(v-for="item in header.top" :key="`top${item.title}`" v-bind="item" :y="headerShift" :h="25")
      GanttHeaderItem(v-for="item in header.bottom" :key="`top${item.x}${item.title}`" v-bind="item" :y="headerShift + 35" :h="25")
    GanttHeaderItem(v-for="item in header.bottom" :key="`bottom${item.x}${item.title}`" v-bind="item" :y="contentHeight" :h="25")
    GanttHeaderItem(v-for="item in header.top" :key="`bottom${item.title}`" v-bind="item" :y="contentHeight + 35" :h="25")
</template>

<style scoped>

</style>
